import { Box } from "@mui/material";
import React from "react";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { IObjectHistoryItem } from "../../queries/object-history/Common";

export type ObjectHistoryCardSubheaderProps = {
    item: IObjectHistoryItem;
    createdBy: string;
    contextObject?: IeLynxObject;
};

export function ObjectHistoryCardSubheader({ item, createdBy, contextObject }: ObjectHistoryCardSubheaderProps) {
    const objectName = (item.objectType !== contextObject?.objectType || item.objectID !== contextObject?.id) && item.objectName
        ? item.objectName
        : undefined;

    return (
        <Box>
            <Box>
                {createdBy}
            </Box>
            {objectName &&
                <Box>
                    {objectName}
                </Box>
            }
        </Box>
    );
}
